export const sections = ['Carburante'];
export const id = '17bX5u34v6qp72GxQyiAfDSpiCQhVOG9_9x-fG4s1cEI';
